"use client";

import styled, { css } from "styled-components";
import { sans as zoram, fontSize18, lineHeightTight, fontWeightSemiBold } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority4 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightSemiBold, fontSize18, lineHeightTight);
const H4Styled = styled.h4.withConfig({
  componentId: "sc-12mz36o-0"
})(["", ";"], internalUseOnlyPriority4);

/**
 * The fourth level heading style. You can override the semantics by passing a different `renderAs` prop to still look like an `h4` but be an `h3` (or other heading) if needed.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - The content inside the heading
 * @param {React.ElementType} [props.renderAs] - The HTML tag string (e.g., `"div"`) or React component to render
 * @returns {React.ReactNode} The H4 component
 */
const H4 = ({
  children,
  renderAs,
  ...props
}) => /*#__PURE__*/_jsx(H4Styled, {
  as: renderAs,
  ...props,
  children: children
});
H4.displayName = "H4";
export default H4;